module.exports = __webpack_public_path__ + "img/video-play.32959851.png";